import { Box, Container, Grid, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import InputField from "../../common/InputField";
import * as Yup from "yup";
import { PrimaryButton } from "../../common/Buttons";
import "../home/homepage.scss";
import { login, vdsLogin } from "../../services/user/UserServices";
import { toast, Toaster } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import DiscoverMoreSection from "../../components/discoverMore";
import { loginPathNames, productId } from "../../constants/constants";
import { useDispatch } from "react-redux";
import Testimonial from "./../../components/discoverMore/Testimonial";
import Areas from "./../../components/discoverMore/Areas";
import Workings from "./../../components/discoverMore/Workings";
import Safety from "./../../components/discoverMore/Safety";
import GeneralVB from "./../../components/discoverMore/GeneralVB";
import JoinNow from "./../../components/discoverMore/JoinNow";
import Footer from "../../components/discoverMore/Footer";
import Introduction from "../../components/discoverMore/Introduction";
import VideoSection from "../../components/videoSection";
import styled from "styled-components";

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (localStorage.getItem("auth")) {
      navigate("/");
    }
  }, []);

  const validate = Yup.object({
    email: Yup.string()
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        t("Must-be-ValidEmail")
      )
      .required(t("required")),
    password: Yup.string().required(t("required")),
  });

  const handleSubmit = async (values, setErrors) => {
    setIsLoading(true);
    let result = await vdsLogin({
      email: values.email,
      password: values.password,
      context: window.location.pathname === "/admin/login" ? "admin" : "user",
      productId: productId,
    });
    setIsLoading(false);
    if (result?.success) {
      const { payLoad = {} } = result;
      localStorage.setItem(
        "phoneNumberConfirmed",
        payLoad?.phoneNumberConfirmed
      );

      if (!payLoad?.mfaToken && !payLoad?.otp) {
        window.location = "/";
      } else if (payLoad?.phoneNumberConfirmed) {
        navigate("/verify-otp", {
          state: {
            mfaTokenId: payLoad?.mfaToken,
            userId: payLoad?.userId,
          },
        });
      }
    } else {
      setErrors({
        password: t(result?.message),
      });

    }
  };

  return (
    <>
      <Toaster />
      <Container
        maxWidth="lg"
        sx={{
          [`@media (min-width: 3800px)`]: {
            maxWidth: "2500px",
          },
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          height="auto"
          spacing={5}
          className="homepage"
          sx={{
            [`@media (min-width: 2560px)`]: {
              minHeight: "88vh",
            },
            [`@media (max-width: 2559px)`]: {
              minHeight: "80vh",
            },
          }}
        >
          <Grid item md={5} className="left-sec">
            <Typography
              className="Fc-heading"
              variant="h2"
              fontWeight={800}
              fontFamily="Futura !important"
            >
              {t("FutureCare")}
            </Typography>
            <Typography
              marginTop={1}
              fontFamily="WixMadefor"
              className="Fc-para"
            >
              {t("login-detail-1")}
            </Typography>
            <Typography
              marginBottom={3}
              fontFamily="WixMadefor"
              className="Fc-para"
            >
              {t("login-detail-2")}
            </Typography>

            <Formik
              initialValues={{
                email: "",
                password: "",
              }}
              validationSchema={validate}
              onSubmit={(values, { setErrors }) => {
                handleSubmit(values, setErrors);
              }}
            >
              {() => (
                <Form
                  style={{
                    width: "80%",
                  }}
                >
                  <InputField
                    name="email"
                    type="email"
                    label={t("input-3")}
                    variant="outlined"
                  />
                  <InputField
                    name="password"
                    type="password"
                    label={t("password")}
                    variant="outlined"
                  />
                  <Typography
                    variant="inherit"
                    textAlign="right"
                    marginBottom="2.5rem"
                  >
                    <Link
                      to="/forget-password"
                      style={{ textDecoration: "none" }}
                    >
                      {t("forget-password")}
                    </Link>
                  </Typography>
                  <PrimaryButton
                    title={t("login")}
                    fullWidth={true}
                    textTransform="initial"
                    isLoading={isLoading}
                    width="100%"
                  />
                </Form>
              )}
            </Formik>
          </Grid>
          <Grid item md={7} className="right-sec">
            <Box
              component="img"
              alt="Login"
              src="/assets/images/login-image.png"
              width="100%"
            />
          </Grid>
        </Grid>

        {/* <Box
          component="div"
          position="absolute"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          bottom={0}
          left="50%"
        >
          <Typography fontWeight="bold">{t("discover-more")}</Typography>
          <div>
            <img src="/assets/icons/down-arrow.png" alt="arrow" />
          </div>
        </Box> */}
      </Container>
      {/* {window.location.pathname === loginPathNames[0] && (
        <DiscoverMoreSection />
      )} */}

      <DiscoverMoreSection />
      <Box as="section" className="introduction-section">
        <Container
          sx={{
            [`@media (min-width: 1500px)`]: {
              maxWidth: "1400px",
            },
            [`@media (min-width: 3800px)`]: {
              maxWidth: "3000px",
            },
          }}
        >
          <Introduction />
        </Container>
      </Box>
      <Box as="section" sx={{ backgroundColor: "#E3E3E330" }}>
        <Container
          sx={{
            [`@media (min-width: 1500px)`]: {
              maxWidth: "1400px",
            },
            [`@media (min-width: 3800px)`]: {
              maxWidth: "3000px",
            },
          }}
        >
          <Areas />
        </Container>
      </Box>

      <Container
        sx={{
          [`@media (min-width: 1500px)`]: {
            maxWidth: "1400px",
          },
          [`@media (min-width: 3800px)`]: {
            maxWidth: "3000px",
          },
        }}
      >
        <Workings />
      </Container>
      <Box as="section" sx={{ background: "#E3E3E330" }}>
        <Container
          sx={{
            [`@media (min-width: 1500px)`]: {
              maxWidth: "1400px",
            },
            [`@media (min-width: 3800px)`]: {
              maxWidth: "3000px",
            },
          }}
        >
          <Safety />
        </Container>
      </Box>

      <Container
        sx={{
          [`@media (min-width: 1500px)`]: {
            maxWidth: "1400px",
          },
          [`@media (min-width: 3800px)`]: {
            maxWidth: "3000px",
          },
        }}
      >
        <GeneralVB />
      </Container>
      <Box as="section" sx={{ background: "#69617D40" }}>
        <Container
          sx={{
            [`@media (min-width: 1500px)`]: {
              maxWidth: "1400px",
            },
            [`@media (min-width: 3800px)`]: {
              maxWidth: "3000px",
            },
          }}
        >
          <Testimonial />
        </Container>
      </Box>
      <Container
        sx={{
          [`@media (min-width: 1500px)`]: {
            maxWidth: "1400px",
          },
          [`@media (min-width: 3800px)`]: {
            maxWidth: "3000px",
          },
        }}
      >
        <JoinNow />
      </Container>
      <Footer />
    </>
  );
};

export default Login;
